// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__354eF","content":"styles_content__ABBwi","row":"styles_row__1AmdV","footer":"styles_footer__TiAn_","phraseLength":"styles_phraseLength__2cH40"};